"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewportLabel = getViewportLabel;
/**
 * Convert a viewport object and modality into a human-readable label.
 */
function getViewportLabel(vp, modality) {
    var _a;
    if (modality === 'ios') {
        return 'iOS';
    }
    const key = `${vp.width}x${vp.height}`;
    const MAP = {
        '375x812': 'Web mobile',
        '810x1010': 'Web iPad portrait',
        '1010x810': 'Web iPad landscape',
        '1366x768': 'Web desktop',
        '412x915': 'Android',
    };
    return (_a = MAP[key]) !== null && _a !== void 0 ? _a : `Web ${vp.width}×${vp.height}`;
}
//# sourceMappingURL=viewport.js.map